import { createFileRoute } from "@tanstack/react-router";
import DealeriVerificati from "@/pages/DealeriVerificati";
import { routeHead } from "@/lib/seo/route-head";
import { loadVerifiedDealers } from "@/lib/seo/verified-dealers-seo";

export const Route = createFileRoute("/uk/verified-dealers/")({
  head: () => routeHead("/uk/verified-dealers/"),
  loader: () => loadVerifiedDealers("UK"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <DealeriVerificati />
  );
}
